import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';
import { useViewActions } from '@mm/state/actions/viewActions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import './MainMenu.pcss';

type Props = {
  isMobile: boolean;
  setDialguesPaneState: () => void;
};

export const useOnSelectMenuItem = (props: Props) => {
  const mainMenuSelected = useSelector(
    (state: StoreState) => state.view.chatbotEditor.mainMenuSelected,
  );
  const activeChatbotId = useSelector((state: StoreState) =>
    activeChatbotIdSelector(state),
  );
  const { history } = useRouter();
  const viewActions = useViewActions();
  const { isMobile, setDialguesPaneState } = props;

  return (slug: number | string, type: string) => {
    if (mainMenuSelected && type === 'page') {
      viewActions.unselectMainMenu();
    }
    if (!mainMenuSelected && type === 'menu') {
      viewActions.selectMainMenu();
      if (isMobile) {
        setDialguesPaneState();
      }
    }

    if (type === 'page') {
      viewActions.activatePageEditor(Number(slug), false);
    }

    history.push(
      BotBuilderRoutes.build.getLink({
        chatbotId: activeChatbotId,
        dialogueId: slug,
      }),
    );
  };
};

export const MainMenu = (props: Props) => {
  const mainMenuSelected = useSelector(
    (state: StoreState) => state.view.chatbotEditor.mainMenuSelected,
  );
  const onSelectMenuItem = useOnSelectMenuItem(props);
  const itemClassName = classnames('main-menu', {
    'main-menu--selected': mainMenuSelected,
  });
  return (
    <div
      className={itemClassName}
      onClick={() => onSelectMenuItem('main-menu', 'menu')}
    >
      <div className="main-menu__title">Main Menu</div>
      <div className="main-menu__notes">
        The first message a new visitor sees
      </div>
    </div>
  );
};
